import type { IconProps } from "@/types/icon";

const Tooth = ({ color = "black", className }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.8243 4.45509C13.8243 2.20731 12.4076 0.444345 10.5187 0.444345C9.6572 0.442313 8.82944 0.779296 8.21429 1.38249C8.15544 1.44018 8.07632 1.47249 7.99392 1.47249C7.91152 1.47249 7.8324 1.44018 7.77355 1.38249C7.16151 0.78235 6.33888 0.445613 5.4817 0.444345C3.62429 0.444345 2.17614 2.20731 2.17614 4.45509C2.09557 6.08288 2.61285 7.68398 3.63059 8.95694C3.66672 8.99988 3.69097 9.05155 3.70091 9.10679C3.71085 9.16202 3.70614 9.2189 3.68725 9.27175C3.28919 10.3761 3.08885 11.5419 3.0954 12.7158C3.09298 13.4245 3.16473 14.1314 3.30948 14.8251C3.35328 15.0338 3.46832 15.2209 3.63488 15.3541C3.80144 15.4874 4.00916 15.5585 4.22244 15.5555C4.45474 15.5568 4.67928 15.4719 4.85259 15.3172C5.0259 15.1625 5.13564 14.949 5.16059 14.718C5.39355 12.5773 6.62133 10.9403 8.01911 10.9403C9.41688 10.9403 10.6447 12.5521 10.8776 14.718C10.9017 14.9426 11.0061 15.151 11.1715 15.3048C11.3369 15.4587 11.5522 15.5477 11.778 15.5555C11.988 15.5542 12.1913 15.481 12.354 15.3481C12.5167 15.2152 12.6289 15.0307 12.6721 14.8251C12.8168 14.1314 12.8886 13.4245 12.8861 12.7158C12.9002 11.5389 12.7063 10.3686 12.3132 9.25916C12.2943 9.20631 12.2896 9.14943 12.2995 9.09419C12.3095 9.03896 12.3337 8.98729 12.3698 8.94435C13.3847 7.67469 13.9018 6.07861 13.8243 4.45509Z"
      fill={color}
    />
  </svg>
);

export default Tooth;
